// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="may-7-2021">May 7, 2021</h3>
      <p>Initial release of the Claims Attributes API</p>
    </div>
  );
};

export default MarkdownComponent;
